import { RootState } from '../store';

export const selectUser = (state: RootState) => state.user.user;
export const selectUserEmail = (state: RootState) => state.user.user?.email;
export const selectUserName = (state: RootState) => state.user.user?.name;
export const selectUserId = (state: RootState) => state.user.user?.id;
export const selectUserPreferences = (state: RootState) => state.user.user?.preferences;
